export default class AnimationOptionModel {
    constructor(
        id: string,
        animation: Object[],
    ) {
        this.id = id;
        this.animation = animation;
    }
}